import { fields } from '../auth/config';

export const MODULE_PREFIX = 'form';


export const FIELD_SPECIFIC_ERRORS: Record<string, string> = {
    "error.api.codeMismatch": fields.forgottenPassword.code,
}
